import React, { Component } from "react";
import "../js/appConstants.js";
import MyBlogs from "../js/codeandtech/MyBlogs";
import TypoGraphy from '@material-ui/core/Typography'
import { Grid, Paper, Typography, List, ListItem } from "@material-ui/core";
import { ThemeProvider } from '@material-ui/core/styles';
import theme from '../theme';


import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
    } from 'react-accessible-accordion';
    
    // Demo styles, see 'Styles' section below for some notes on use.
    import 'react-accessible-accordion/dist/fancy-example.css';
    

class Home extends Component {

constructor(props){
    super(props)
    this.state = {
        appConstants: window.appConstants
    }
    }  
    NavUrl(value){
        window.location.href = window.location.href + value;
    }
    
  render() {
    var appConstants = this.state.appConstants;

    if(appConstants && appConstants.AppName === "CodeAndTech"){
        return (
        
            <div>
                <div style={{ marginTop: 20, padding: 30 }}>
                    <Grid container spacing={40} justify="center">
                        <TypoGraphy variant="h4">
                            <center>CodeAndTech !!!</center>
                        </TypoGraphy>
                    </Grid>
                    
                        <div className="pad-top-30 pad-left-page">
                        <div class="row">
                            <div class="col-sm-7 col-md-5">
                                <div class="">
                                        <div class="">
                                            <div class="col-4 col-m-3"  height="200" width="225">
                                                    Learn to Code 
                                                    <br/>
                                                    <img alt="LearnToCodeQnAs" onClick={() => this.NavUrl('LearnToCode')} src={window.location.origin + '/images/code.png'}   height="150" width="225"/>
                                                </div>
                                                <div class="col-4 col-m-3">
                                                    My AWS Offering
                                                    <br/>
                                                    <img alt="CloudOpsGuru.com"  onClick={() => this.NavUrl('AWSDedication')}  src="images\aws_new.jpg"  height="150" width="225"/>
                                                </div>
                                                <div class="col-4 col-m-3">
                                                    Open Source
                                                    <br/>
                                                    <img alt="OpenSource"  onClick={() => this.NavUrl('Opensource')}  src="images\opensource.png"  height="150" width="225"/>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                            </div>           
                            
                            <div class="row">
                                    <div class="">
                                        <div class="col-4 col-m-3" height="200" width="225">
                                            Microsoft
                                            <br/>
                                            <img alt="Microsoft" ClassName="handCursor" onClick={() => this.NavUrl('Microsoft')}  src="images\microsoft.jpg"  height="150" width="225"/>
                                        </div>
                                        <div class="col-4 col-m-3">
                                            GIT It !!!
                                            <br/>
                                            <img alt="github"  ClassName="handCursor" onClick={() => this.NavUrl('GIT')}  src="images\github.gif"  height="150" width="225"/>
                                        </div>
                                        <div class="col-4 col-m-3">
                                            IOT!!!
                                            <br/>
                                            <img alt="IoT"  ClassName="handCursor" onClick={() => this.NavUrl('')}  src="images\iot.png"/>
                                        </div>
                                    </div>
                            </div>
                            
                        
                        </div>
                </div>
            </div>
        );
    }
    else{
        return (
            <div>
                <div style={{ marginTop: 20, padding: 30 }}>
                    <Grid container spacing={40} justify="center">
                        <TypoGraphy variant="h4">
                            <center>CloudOpsGurus !!!</center>
                        </TypoGraphy>
                    </Grid>
                    <div className="pad-left-page">
                    <Accordion>
                            <AccordionItem>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                    AWS Certification
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                Hi Guys, with inspiration from ACloud.Guru and Jayendrapatil.com, I thought will provide a AWS help/tips for exam aspirants.<br/>
                                <br/>
                                AWS Solution Architect/Developer/SysOpsAdmin – Associate Exam Resources <br/>
                                AWS Devops/Solutions Architect - Professional <br/>
                                AWS Security Specialty <br/>
                                *Note: I am 11x AWS Certified as of Feb 2021
                                <br/><br/>
                                - Learnt the CSA, CDA, SysOps course from ACloud.Guru. This is a very good material which covers 50/60 % for the exams <br/>
                                - Udemy.com - Did some lessons and & exams - This is similar to ACloud.Guru<br/>
                                - aws.training - Took practice exams for CSA, CDA, SysOps Associate <br/>
                                - Whizlabs.com - Took exams for CSA, CDA, SysOps Associate<br/>
                                - theCertSchool.com - Took exams for CSA, CDA, SysOps Associate <br/>
                                - devcertguru.com, aiotestking.com - These have a ton of sample exams which does really help <br/>
                                
                                <br/>
                                <font color='red'>NOTE:</font> I started this for fun with sole purpose for tracking few tips and tricks that i could brush through while i rush for the exams
                                The idea was not to provide this as a comprehensive website/solution or a learning portal.
                                Nothing comes as close as learning from AWS Documentation.
                                <br/><br/>
                                Happy Coding... CloudOpsGurus !!!

                                <br/>

                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>

                    <MyBlogs></MyBlogs>
                </div>
                </div>
            </div>
        )
    }
  }
}
 
export default Home;